import React from "react";
const SvgBBiconsHandlebar = props => (
    <svg viewBox="0 0 300 20" {...props}>
        <g>
            <path d="M 286.111 20 L 13.42 20 C 7.14 20 2.05 15.52 2.05 10 C 2.05 4.48 7.14 0 13.42 0 L 286.111 0 C 292.391 0 297.471 4.48 297.471 10 C 297.471 15.52 292.421 20 286.111 20 Z" />
        </g>
    </svg>
);

export default SvgBBiconsHandlebar;